import Api from '../http.service';
import store from '../../store';

/**
 *
 * @param {object} payload
 */

export const upload = (payload) =>
  Api.POST({
    url: 'file/upload',
    data: payload,
    headers: {
      header: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${
          store.getState()?.requestToken?.barearToken || ''
        }`,
      },
    },
  });

export const uploadPassport = (file) =>
  Api.POST({
    url: '/passport',
    data: file,
    headers: {
      header: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${
          store.getState()?.requestToken?.barearToken || ''
        }`,
      },
    },
  });

export const deleteFile = (fileName) =>
  Api.DELETE({
    url: `file/delete/${fileName}`,
    headers: {
      header: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${
          store.getState()?.requestToken?.barearToken || ''
        }`,
      },
    },
  });
